import React from "react";
import CatalogueEditor from "../../common/catalogue/CatalogueEditor";

export default function SalonServicesPage() {
  return <CatalogueEditor kind="salon" />;
}
